import { createSlice } from 'react-context-toolkit'
 
const slice = createSlice({
  name: 'price-calculator',
  initialState: {
    currentPackage: {},
    currentProduct: {}
  },
  reducers: {
  },
})
export const { increment, incrementBy } = slice.actions
export const shopSelectorByProperty = (property) => (state) => state[slice.name][property]
export const shopSelector = () => (state) => state[slice.name]
export default slice